export enum RoleDeclare {
    ROLE_CAN_CREATE_EMPLOYEE = "ROLE_CAN_CREATE_EMPLOYEE",
    ROLE_CAN_UPDATE_EMPLOYEE = "ROLE_CAN_UPDATE_EMPLOYEE",
    ROLE_CAN_SEE_EMPLOYEE = "ROLE_CAN_SEE_EMPLOYEE",
    ROLE_CAN_DELETE_EMPLOYEE = "ROLE_CAN_DELETE_EMPLOYEE",

    ROLE_CAN_CREATE_CUSTOMER = "ROLE_CAN_CREATE_CUSTOMER",
    ROLE_CAN_UPDATE_CUSTOMER = "ROLE_CAN_UPDATE_CUSTOMER",
    ROLE_CAN_SEE_CUSTOMER = "ROLE_CAN_SEE_CUSTOMER",
    ROLE_CAN_DELETE_CUSTOMER = "ROLE_CAN_DELETE_CUSTOMER",

    ROLE_CAN_CREATE_POST_OFFICE = "ROLE_CAN_CREATE_POST_OFFICE",
    ROLE_CAN_UPDATE_POST_OFFICE = "ROLE_CAN_UPDATE_POST_OFFICE",
    ROLE_CAN_SEE_POST_OFFICE = "ROLE_CAN_SEE_POST_OFFICE",
    ROLE_CAN_DELETE_POST_OFFICE = "ROLE_CAN_DELETE_POST_OFFICE",

    ROLE_CAN_CREATE_BILL_LADING = "ROLE_CAN_CREATE_BILL_LADING",
    ROLE_CAN_UPDATE_BILL_LADING = "ROLE_CAN_UPDATE_BILL_LADING",
    ROLE_CAN_SEE_BILL_LADING = "ROLE_CAN_SEE_BILL_LADING",
    ROLE_CAN_DELETE_BILL_LADING = "ROLE_CAN_DELETE_BILL_LADING",

    ROLE_CAN_CREATE_ASSIGN_PICKUP = "ROLE_CAN_CREATE_ASSIGN_PICKUP",
    ROLE_CAN_SEE_ASSIGN_PICKUP = "ROLE_CAN_SEE_ASSIGN_PICKUP",

    ROLE_CAN_SEE_POSITION_SHIPPER = "ROLE_CAN_SEE_POSITION_SHIPPER",

    ROLE_CAN_SEE_WAREHOUSE = "ROLE_CAN_SEE_WAREHOUSE",
    ROLE_CAN_STOCK_IN = "ROLE_CAN_STOCK_IN",
    ROLE_CAN_STOCK_IN_FAST = "ROLE_CAN_STOCK_IN_FAST",
    ROLE_CAN_STOCK_OUT_DELIVERY = "ROLE_CAN_STOCK_OUT_DELIVERY",
    ROLE_CAN_STOCK_OUT_DELIVERY_PARTNER = "ROLE_CAN_STOCK_OUT_DELIVERY_PARTNER",
    ROLE_CAN_STOCK_OUT_RE_TRANSPORT = "ROLE_CAN_STOCK_OUT_RE_TRANSPORT",
    ROLE_CAN_MANAGE_TRANSHIPMENT_FROM = "ROLE_CAN_MANAGE_TRANSHIPMENT_FROM",
    ROLE_CAN_MANAGE_TRANSHIPMENT_TO = "ROLE_CAN_MANAGE_TRANSHIPMENT_TO",
    ROLE_CAN_MANAGE_REPORT_DELIVERY = "ROLE_CAN_MANAGE_REPORT_DELIVERY",
    ROLE_CAN_CHIA_CHON = "ROLE_CAN_CHIA_CHON",

    ROLE_CAN_SEE_LADING_CODE = "ROLE_CAN_SEE_LADING_CODE",
    ROLE_CAN_CREATE_LADING_CODE = "ROLE_CAN_CREATE_LADING_CODE",

    ROLE_CAN_CREATE_PARTNER = "ROLE_CAN_CREATE_PARTNER",
    ROLE_CAN_UPDATE_PARTNER = "ROLE_CAN_UPDATE_PARTNER",
    ROLE_CAN_SEE_PARTNER = "ROLE_CAN_SEE_PARTNER",
    ROLE_CAN_DELETE_PARTNER = "ROLE_CAN_DELETE_PARTNER",

    ROLE_CAN_SEE_LADING_ERROR = "ROLE_CAN_SEE_LADING_ERROR",
    ROLE_CAN_CREATE_LADING_ERROR = "ROLE_CAN_CREATE_LADING_ERROR",

    ROLE_CAN_CREATE_NOTIFICATION_EMPLOYEE = "ROLE_CAN_CREATE_NOTIFICATION_EMPLOYEE",
    ROLE_CAN_SEE_NOTIFICATION_EMPLOYEE = "ROLE_CAN_SEE_NOTIFICATION_EMPLOYEE",

    ROLE_CAN_CREATE_NOTIFICATION_CUSTOMER = "ROLE_CAN_CREATE_NOTIFICATION_CUSTOMER",
    ROLE_CAN_SEE_NOTIFICATION_CUSTOMER = "ROLE_CAN_SEE_NOTIFICATION_CUSTOMER",

    ROLE_CAN_CREATE_FREIGHT_SERVICE = "ROLE_CAN_CREATE_FREIGHT_SERVICE",
    ROLE_CAN_UPDATE_FREIGHT_SERVICE = "ROLE_CAN_UPDATE_FREIGHT_SERVICE",
    ROLE_CAN_SEE_FREIGHT_SERVICE = "ROLE_CAN_SEE_FREIGHT_SERVICE",
    ROLE_CAN_DELETE_FREIGHT_SERVICE = "ROLE_CAN_DELETE_FREIGHT_SERVICE",

    ROLE_CAN_CREATE_FREIGHT_SERVICE_ADD = "ROLE_CAN_CREATE_FREIGHT_SERVICE_ADD",
    ROLE_CAN_UPDATE_FREIGHT_SERVICE_ADD = "ROLE_CAN_UPDATE_FREIGHT_SERVICE_ADD",
    ROLE_CAN_SEE_FREIGHT_SERVICE_ADD = "ROLE_CAN_SEE_FREIGHT_SERVICE_ADD",
    ROLE_CAN_DELETE_FREIGHT_SERVICE_ADD = "ROLE_CAN_DELETE_FREIGHT_SERVICE_ADD",

    ROLE_CAN_CREATE_PRICE_LIST = "ROLE_CAN_CREATE_PRICE_LIST",
    ROLE_CAN_UPDATE_PRICE_LIST = "ROLE_CAN_UPDATE_PRICE_LIST",
    ROLE_CAN_SEE_PRICE_LIST = "ROLE_CAN_SEE_PRICE_LIST",
    ROLE_CAN_DELETE_PRICE_LIST = "ROLE_CAN_DELETE_PRICE_LIST",

    ROLE_CAN_UPLOAD_SITE = "ROLE_CAN_UPLOAD_SITE",
    ROLE_CAN_UPDATE_SITE = "ROLE_CAN_UPDATE_SITE",

    ROLE_CAN_CREATE_COMPLAINT = "ROLE_CAN_CREATE_COMPLAINT",
    ROLE_CAN_UPDATE_COMPLAINT = "ROLE_CAN_UPDATE_COMPLAINT",
    ROLE_CAN_SEE_COMPLAINT = "ROLE_CAN_SEE_COMPLAINT",

    ROLE_CAN_MANAGE_PERMISSION = "ROLE_CAN_MANAGE_PERMISSION",

    ROLE_CAN_REVENUE_CUSTOMER_PERMISSION = "ROLE_CAN_REVENUE_CUSTOMER_PERMISSION",
    ROLE_CAN_REVENUE_EMPLOYEE_PERMISSION = "ROLE_CAN_REVENUE_EMPLOYEE_PERMISSION",
    ROLE_CAN_REVENUE_PARTNER_PERMISSION = "ROLE_CAN_REVENUE_PARTNER_PERMISSION",
    ROLE_CAN_REVENUE_POST_OFFICE_PERMISSION = "ROLE_CAN_REVENUE_POST_OFFICE_PERMISSION",
    ROLE_CAN_EXPENDITURE_CUSTOMER_PERMISSION = "ROLE_CAN_EXPENDITURE_CUSTOMER_PERMISSION",
    ROLE_CAN_EXPENDITURE_POST_OFFICE_PERMISSION = "ROLE_CAN_EXPENDITURE_POST_OFFICE_PERMISSION",

    ROLE_CAN_SEE_REVENUE_PICKING_LIST_PERMISSION = "ROLE_CAN_SEE_REVENUE_PICKING_LIST_PERMISSION",
    ROLE_CAN_SEE_EXPENDITURE_PICKING_LIST_PERMISSION = "ROLE_CAN_SEE_EXPENDITURE_PICKING_LIST_PERMISSION",
    ROLE_CAN_DELETE_REVENUE_PICKING_LIST_PERMISSION = "ROLE_CAN_DELETE_REVENUE_PICKING_LIST_PERMISSION",
    ROLE_CAN_DELETE_EXPENDITURE_PICKING_LIST_PERMISSION = "ROLE_CAN_DELETE_EXPENDITURE_PICKING_LIST_PERMISSION",
    ROLE_CAN_CONFIRM_REVENUE_PICKING_LIST_PERMISSION = "ROLE_CAN_CONFIRM_REVENUE_PICKING_LIST_PERMISSION",
    ROLE_CAN_CONFIRM_EXPENDITURE_PICKING_LIST_PERMISSION = "ROLE_CAN_CONFIRM_EXPENDITURE_PICKING_LIST_PERMISSION",

    ROLE_CAN_SEE_REPORT = "ROLE_CAN_SEE_REPORT",
    ROLE_CAN_UPDATE_COST = "ROLE_CAN_UPDATE_COST",
    ROLE_CAN_UPDATE_COST_TRANSHIPMENT = "ROLE_CAN_UPDATE_COST_TRANSHIPMENT",

    ROLE_CAN_SEE_ARTICLE = "ROLE_CAN_SEE_ARTICLE",
    ROLE_CAN_CREATE_ARTICLE = "ROLE_CAN_CREATE_ARTICLE",
    ROLE_CAN_UPDATE_ARTICLE = "ROLE_CAN_UPDATE_ARTICLE",
    ROLE_CAN_DELETE_ARTICLE = "ROLE_CAN_DELETE_ARTICLE",

    ROLE_CAN_SEE_API_KEY = 'ROLE_CAN_SEE_API_KEY',
    ROLE_CAN_SEE_MEMBER = 'ROLE_CAN_SEE_MEMBER',
}
